import { stringify, parse } from 'qs';
import { useRouterHistory } from 'react-router';
import { createHashHistory } from 'history';
const stringifyQuery = query => stringify(query, { arrayFormat: 'brackets' });
export default useRouterHistory(createHashHistory)({
    parseQueryString: parse,
    stringifyQuery,
});



// WEBPACK FOOTER //
// ./src/history.js